import {z} from "zod";
import {
  OfferBindingValue,
  OfferCatalogBlock,
  OfferChapter,
  OfferLiteralValue,
  OfferRichTextBlock,
  OfferRichTextContent,
  OfferSupplierSelection,
  OfferVariable,
  OpenExpedientCustomerOfferBody,
} from "@project/sdk/sales/zod";

const variable = OfferVariable.strict().extend({
  value: z.union([OfferLiteralValue.strict(), OfferBindingValue.strict(), z.null()]),
});
const richText = OfferRichTextContent.strict().extend({variables: z.array(variable)});
const block = z.union([
  OfferRichTextBlock.strict().extend({content: richText}),
  OfferCatalogBlock.strict().extend({
    selectedSupplierOffers: z.array(OfferSupplierSelection.strict()),
  }),
]);
const chapter = OfferChapter.strict().extend({
  applyCommission: OfferChapter.shape.applyCommission.unwrap(),
  blocks: z.array(block),
});
export const openExpedientCustomerOfferFormSchema = OpenExpedientCustomerOfferBody.strict().extend({
  content: OpenExpedientCustomerOfferBody.shape.content.strict().extend({
    header: richText,
    footer: richText,
    chapters: z.array(chapter),
  }),
});
export type OpenExpedientCustomerOfferFormPayload = z.output<
  typeof openExpedientCustomerOfferFormSchema
>;
export const draftOpenExpedientCustomerOfferFormSchema =
  openExpedientCustomerOfferFormSchema.partial();
export type DraftOpenExpedientCustomerOfferFormPayload = z.output<
  typeof draftOpenExpedientCustomerOfferFormSchema
>;
